var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { ManagerHistorySearchType } from '../../../enums';
import { PartialType } from '../../../utils';
import { GetManyQueryDto } from '../../common';
export class GetManyManagerHistoryQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyManagerHistoryQueryDto.prototype, "fromCreatedAt", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyManagerHistoryQueryDto.prototype, "toCreatedAt", void 0);
__decorate([
    IsEnum(ManagerHistorySearchType),
    IsOptional(),
    __metadata("design:type", String)
], GetManyManagerHistoryQueryDto.prototype, "managerHistorySearchType", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyManagerHistoryQueryDto.prototype, "managerId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyManagerHistoryQueryDto.prototype, "searchKeyword", void 0);
